!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define(r) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.da = r());
}(this, function () {
  "use strict";

  return [{
    locale: "da",
    pluralRuleFunction: function (e, r) {
      var t = String(e).split("."),
        o = t[0],
        i = Number(t[0]) == e;
      return r ? "other" : 1 != e && (i || 0 != o && 1 != o) ? "other" : "one";
    },
    fields: {
      year: {
        displayName: "år",
        relative: {
          0: "i år",
          1: "næste år",
          "-1": "sidste år"
        },
        relativeTime: {
          future: {
            one: "om {0} år",
            other: "om {0} år"
          },
          past: {
            one: "for {0} år siden",
            other: "for {0} år siden"
          }
        }
      },
      "year-short": {
        displayName: "år",
        relative: {
          0: "i år",
          1: "næste år",
          "-1": "sidste år"
        },
        relativeTime: {
          future: {
            one: "om {0} år",
            other: "om {0} år"
          },
          past: {
            one: "for {0} år siden",
            other: "for {0} år siden"
          }
        }
      },
      month: {
        displayName: "måned",
        relative: {
          0: "denne måned",
          1: "næste måned",
          "-1": "sidste måned"
        },
        relativeTime: {
          future: {
            one: "om {0} måned",
            other: "om {0} måneder"
          },
          past: {
            one: "for {0} måned siden",
            other: "for {0} måneder siden"
          }
        }
      },
      "month-short": {
        displayName: "md.",
        relative: {
          0: "denne md.",
          1: "næste md.",
          "-1": "sidste md."
        },
        relativeTime: {
          future: {
            one: "om {0} md.",
            other: "om {0} mdr."
          },
          past: {
            one: "for {0} md. siden",
            other: "for {0} mdr. siden"
          }
        }
      },
      day: {
        displayName: "dag",
        relative: {
          0: "i dag",
          1: "i morgen",
          2: "i overmorgen",
          "-2": "i forgårs",
          "-1": "i går"
        },
        relativeTime: {
          future: {
            one: "om {0} dag",
            other: "om {0} dage"
          },
          past: {
            one: "for {0} dag siden",
            other: "for {0} dage siden"
          }
        }
      },
      "day-short": {
        displayName: "dag",
        relative: {
          0: "i dag",
          1: "i morgen",
          2: "i overmorgen",
          "-2": "i forgårs",
          "-1": "i går"
        },
        relativeTime: {
          future: {
            one: "om {0} dag",
            other: "om {0} dage"
          },
          past: {
            one: "for {0} dag siden",
            other: "for {0} dage siden"
          }
        }
      },
      hour: {
        displayName: "time",
        relative: {
          0: "i den kommende time"
        },
        relativeTime: {
          future: {
            one: "om {0} time",
            other: "om {0} timer"
          },
          past: {
            one: "for {0} time siden",
            other: "for {0} timer siden"
          }
        }
      },
      "hour-short": {
        displayName: "t.",
        relative: {
          0: "i den kommende time"
        },
        relativeTime: {
          future: {
            one: "om {0} time",
            other: "om {0} timer"
          },
          past: {
            one: "for {0} time siden",
            other: "for {0} timer siden"
          }
        }
      },
      minute: {
        displayName: "minut",
        relative: {
          0: "i det kommende minut"
        },
        relativeTime: {
          future: {
            one: "om {0} minut",
            other: "om {0} minutter"
          },
          past: {
            one: "for {0} minut siden",
            other: "for {0} minutter siden"
          }
        }
      },
      "minute-short": {
        displayName: "min.",
        relative: {
          0: "i det kommende minut"
        },
        relativeTime: {
          future: {
            one: "om {0} min.",
            other: "om {0} min."
          },
          past: {
            one: "for {0} min. siden",
            other: "for {0} min. siden"
          }
        }
      },
      second: {
        displayName: "sekund",
        relative: {
          0: "nu"
        },
        relativeTime: {
          future: {
            one: "om {0} sekund",
            other: "om {0} sekunder"
          },
          past: {
            one: "for {0} sekund siden",
            other: "for {0} sekunder siden"
          }
        }
      },
      "second-short": {
        displayName: "sek.",
        relative: {
          0: "nu"
        },
        relativeTime: {
          future: {
            one: "om {0} sek.",
            other: "om {0} sek."
          },
          past: {
            one: "for {0} sek. siden",
            other: "for {0} sek. siden"
          }
        }
      }
    }
  }, {
    locale: "da-GL",
    parentLocale: "da"
  }];
});